export const createTopIssuesCategories = (categoriesFilters: string[]) => {
  let categories: string[] = [];
  categories.push('');
  if (categoriesFilters && categoriesFilters.length > 0) {
    categoriesFilters.map(category => categories.push(category));
  }
  return categories;
};
